import { Component, DestroyRef, inject, input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone: true,
  selector: 'app-max-length',
  templateUrl: './max-length.html',
  styleUrl: './max-length.scss',
})
export class MaxLengthComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  formCtrl = input.required<FormControl<any>>();
  errorMsg = '';
  errorValue = '';

  ngOnInit() {
    this.updateErrorMsg();
    this.formCtrl()
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.updateErrorMsg();
      });
  }

  private updateErrorMsg() {
    const ctrl = this.formCtrl();
    const maxlengthError = ctrl.errors?.['maxlength'];
    const maxlengthValue = ctrl.errors?.['max'];
    this.errorMsg = maxlengthError
      ? `Maximum number of characters is ${maxlengthError.requiredLength}`
      : '';
    this.errorValue = maxlengthValue
      ? `Maximum number is ${maxlengthValue.max}`
      : '';
  }
}
